
// ViewCube.js
import * as THREE from 'three';
import '../../Styles/viewcube.css';
import ThreeJSFunctions from './ThreeJSFunctions';
import Experience from '../Experience.js';



let experience = null;

export class ViewCube {
    constructor({ camera, renderer, container }) {

        if (!experience) {
            experience = new Experience();
        }
        

        //console.log("camera sent to viewcube:", camera)

        this.camera = camera;
        this.rendererMain = renderer;
        this.controls = this.camera.controls;
        this.container = container;

        this.size = 100;
        this.hoveredFace = -1;

        this.scene = new THREE.Scene();
        this.cubeCamera = new THREE.PerspectiveCamera(50, 1, 0.1, 10);
        this.cubeCamera.position.z = 2;

        this.viewCubeRenderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
        this.viewCubeRenderer.setSize(this.size, this.size);
        this.viewCubeRenderer.domElement.className = 'viewcube-canvas';
        container.appendChild(this.viewCubeRenderer.domElement);

        this.labels = ["Right", "Left", "Top", "Bottom", "Front", "Back"];
        this.defaultMaterials = this.labels.map(label => this.createFaceMaterial(label, false));
        this.hoverMaterials = this.labels.map(label => this.createFaceMaterial(label, true));
        this.materials = [...this.defaultMaterials];

        const geometry = new THREE.BoxGeometry(1, 1, 1);
        this.cube = new THREE.Mesh(geometry, this.materials);
        this.scene.add(this.cube);

        this.raycaster = new THREE.Raycaster();
        this.pointer = new THREE.Vector2();

        this.viewCubeRenderer.domElement.addEventListener('pointermove', this.onPointerMove.bind(this));
        this.viewCubeRenderer.domElement.addEventListener('pointerdown', this.onPointerDown.bind(this));
        this.viewCubeRenderer.domElement.addEventListener('dblclick', this.onDoubleDown.bind(this));
    }

    createFaceMaterial(text, hovered) {
        const size = 128;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext('2d');
        ctx.fillStyle = hovered ? '#f89335' : '#ffffff';
        ctx.fillRect(0, 0, size, size);

        ctx.fillStyle = hovered ? '#ffffff' : '#f89335';
        ctx.font = 'bold 36px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, size / 2, size / 2);

        const texture = new THREE.CanvasTexture(canvas);
        return new THREE.MeshBasicMaterial({ map: texture });
    }

    onPointerMove(event) {

        //console.log("we're moving pointer?")
        const bounds = this.viewCubeRenderer.domElement.getBoundingClientRect();
        this.pointer.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1;
        this.pointer.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1;

        this.raycaster.setFromCamera(this.pointer, this.cubeCamera);
        const intersects = this.raycaster.intersectObject(this.cube, true);

        const faceIndex = intersects.length > 0 ? intersects[0].face.materialIndex : -1;
        if (faceIndex !== this.hoveredFace) {
            this.hoveredFace = faceIndex;
            this.updateMaterials();
        }
    }

    onDoubleDown(event)
    {

        //console.log(this.camera)

        let { current } = this.camera.projection;
        
        if(current === "Perspective")
        {
            //console.log("current === Perspective")
            this.camera.projection = "Orthographic";

        }
        else
        {
            //console.log("current === Orthographic")
            this.camera.projection = "Perspective";
        }


        //console.log(current)
        //console.log("DOUBLE TAP!");



    }

    onPointerDown(event) {

        //console.log("pointer is down?", event)
        if (this.hoveredFace !== -1) {
            this.snapToFace(this.hoveredFace);
        }
    }

    updateMaterials() {
        this.cube.material = this.labels.map((label, i) => {
            return i === this.hoveredFace ? this.hoverMaterials[i] : this.defaultMaterials[i];
        });
    }

    update() {
        this.cube.quaternion.copy(this.camera.three.quaternion).invert();
        this.viewCubeRenderer.render(this.scene, this.cubeCamera);
    }

    snapToFace(index) {

        //console.log("we're snapping?")
        const directions = [
            new THREE.Vector3(1, 0, 0),   // Right
            new THREE.Vector3(-1, 0, 0),  // Left
            new THREE.Vector3(0, 1, 0),   // Top
            new THREE.Vector3(0, -1, 0),  // Bottom
            new THREE.Vector3(0, 0, 1),   // Front
            new THREE.Vector3(0, 0, -1),  // Back
        ];

        const direction = directions[index];
        if (!direction) return;
        //console.log("controls", this.controls)

        // You can pass a target object to center on it; for now, use null to center on origin

        //let meshgroup = this.manager.ReturnMeshGroup();
        let meshgroup = experience.world.world.scene.three.children[2];
        //console.log(meshgroup)
        ThreeJSFunctions.SnapToViewCubeFace(this.camera, this.controls, direction, meshgroup, 10);

        // setTimeout(() => {
        //     ThreeJSFunctions.SnapToViewCubeFace(
        //         this.camera, this.controls, direction, this.manager.ReturnMeshGroup()
        //     );
        //     }, 50); // slight delay gives time for any UI transitions
        }
}